module.exports = function() {
  return new Worker(__webpack_public_path__ + "99e83b6eeed4971515f2.worker.js");
};